import React from "react";
import { Text, Stack, Image, Flex, StackProps, Center } from "@chakra-ui/react";

export type EmptyVariants = "search" | "filter" | undefined;

export type EmptyProps = {
  title?: string;
  message: string;
  imageSrc?: string;
  variant?: EmptyVariants;
};

type EmptyVariantProps = Required<Pick<EmptyProps, "message" | "imageSrc">>;

const emptySearchVariant: EmptyVariantProps = {
  message: "Your search did not yield any results.",
  imageSrc: "/img/glasses.png",
};
const emptyFilterVariant: EmptyVariantProps = {
  message: "Try a different set of filters to find what you’re looking for.",
  imageSrc: "/img/missedTarget.png",
};

const imageUrlPrefix = !!process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "";

const Empty = ({
  title = "No results found",
  message: _message,
  children,
  imageSrc: _imageSrc = "/img/desk.png",
  variant,
  ...rest
}: React.PropsWithChildren<EmptyProps & StackProps>): React.ReactElement => {
  let message = _message;
  let imageSrc = _imageSrc;
  switch (variant) {
    case "search":
      message = emptySearchVariant.message;
      imageSrc = emptySearchVariant.imageSrc;
      break;
    case "filter":
      message = emptyFilterVariant.message;
      imageSrc = emptyFilterVariant.imageSrc;
      break;
  }
  return (
    <Center minHeight="400px">
      <Stack spacing={12} align="center" {...rest}>
        <Stack spacing={3} align="center">
          <Text textStyle="h2" fontWeight="black">
            {title}
          </Text>
          <Text textAlign="center" color="gray.600">
            {message}
          </Text>
        </Stack>
        <Flex px={6}>
          <Image src={`${imageUrlPrefix}${imageSrc}`} alt="Nothing found" />
        </Flex>
        <Flex w="100%">{children}</Flex>
      </Stack>
    </Center>
  );
};

export default Empty;
